// Stroke icons for the profile page. Decorative: aria-hidden.
const Svg = ({ size = 18, width = 2, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={width}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
)

export const IconPin = ({ size }) => (
  <Svg size={size}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </Svg>
)
export const IconClock = ({ size }) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Svg>
)
export const IconGlobe = ({ size }) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18Z" />
  </Svg>
)
export const IconLink = ({ size }) => (
  <Svg size={size}>
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
    <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  </Svg>
)
export const IconMessage = ({ size }) => (
  <Svg size={size}>
    <path d="M21 11.5a8.4 8.4 0 0 1-12.4 7.4L3 21l2.1-5.6A8.5 8.5 0 1 1 21 11.5Z" />
  </Svg>
)
export const IconBookmark = ({ size, filled }) => (
  <svg
    width={size || 18}
    height={size || 18}
    viewBox="0 0 24 24"
    fill={filled ? "currentColor" : "none"}
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z" />
  </svg>
)
export const IconMore = ({ size }) => (
  <Svg size={size} width={2.4}>
    <circle cx="5" cy="12" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="19" cy="12" r="1" />
  </Svg>
)
export const IconPencil = ({ size = 16 }) => (
  <Svg size={size}>
    <path d="M4 20h4L19 9l-4-4L4 16Z" />
  </Svg>
)
export const IconCamera = ({ size }) => (
  <Svg size={size}>
    <path d="M4 8h3l2-3h6l2 3h3v11H4Z" />
    <circle cx="12" cy="13" r="3.5" />
  </Svg>
)
export const IconImage = ({ size = 16 }) => (
  <Svg size={size}>
    <rect x="3" y="4" width="18" height="16" rx="3" />
    <circle cx="9" cy="10" r="2" />
    <path d="m21 16-5-5-9 9" />
  </Svg>
)
export const IconUpload = ({ size = 17 }) => (
  <Svg size={size}>
    <path d="M12 16V4" />
    <path d="m7 9 5-5 5 5" />
    <path d="M4 20h16" />
  </Svg>
)
export const IconPlus = ({ size = 15 }) => (
  <Svg size={size} width={2.2}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </Svg>
)
export const IconCheck = ({ size = 18, color }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color || "currentColor"}
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="m5 12 5 5 9-10" />
  </svg>
)
export const IconClose = ({ size = 16 }) => (
  <Svg size={size} width={2.2}>
    <path d="M6 6l12 12" />
    <path d="M18 6 6 18" />
  </Svg>
)
export const IconArrow = ({ size = 16 }) => (
  <Svg size={size}>
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </Svg>
)
export const IconChevron = ({ size = 16 }) => (
  <Svg size={size}>
    <path d="m9 6 6 6-6 6" />
  </Svg>
)
export const IconHeart = ({ size = 16 }) => (
  <Svg size={size}>
    <path d="M19 14c1.5-1.5 3-3.2 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.8 0-3 .5-4.5 2-1.5-1.5-2.7-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4 3 5.5l7 7Z" />
  </Svg>
)
export const IconEyeOff = ({ size = 16 }) => (
  <Svg size={size}>
    <path d="M2 12s3.5-7 10-7c2 0 3.7.6 5.1 1.5" />
    <path d="M22 12s-3.5 7-10 7c-2 0-3.7-.6-5.1-1.5" />
    <path d="M3 3l18 18" />
  </Svg>
)
